import { Auth0Client } from "@auth0/auth0-spa-js";
import OrganizationClient from "./OrganizationClient";

export class OrganizationApi {
  private organizationClient: OrganizationClient;

  constructor(auth0Client: Auth0Client) {
    this.organizationClient = new OrganizationClient(auth0Client);
  }

  getOrganization(orgId: string) {
    return this.organizationClient.getOrganization(orgId);
  }

  getOrganizationById(orgId: string) {
    return this.organizationClient.getOrganizationById(orgId);
  }

  listOrganizations() {
    return this.organizationClient.listOrganizations();
  }
}

export default OrganizationApi;
